/** Formats a score for display: `1000000` → `1 000 000` (space thousands). */
export function formatScore(score: number): string {
  const abs = Math.abs(Math.trunc(score));
  const digits = String(abs);
  const parts: string[] = [];

  let i = digits.length;
  while (i > 0) {
    const start = Math.max(0, i - 3);
    parts.unshift(digits.slice(start, i));
    i = start;
  }

  const grouped = parts.join(' ');
  return score < 0 ? `-${grouped}` : grouped;
}

/**
 * Widest `formatScore` string with the same digit count as `score`.
 * Use as an invisible layout placeholder so HUD width only jumps when the
 * digit count changes (e.g. 99 → 100), not on every score tick.
 */
export function formatScoreSlot(score: number): string {
  const digitCount = String(Math.abs(Math.trunc(score))).length;
  const maxSameDigits = 10 ** digitCount - 1;
  return formatScore(maxSameDigits);
}

